import { useEffect, useRef } from "react";

export default function useAutoSaveCustomer(
  assignedCustomers,
  updateCustomerData
) {
  const originalCustomersRef = useRef([]);

  useEffect(() => {
    if (assignedCustomers) {
      // Update the original copy when the assigned customers change.
      originalCustomersRef.current = assignedCustomers.map((cust) => ({
        ...cust,
      }));
    }
  }, [assignedCustomers]);

  const autoSaveCustomer = async (index) => {
    const customer = assignedCustomers[index];
    const original = originalCustomersRef.current[index];
    if (JSON.stringify(customer) !== JSON.stringify(original)) {
      try {
        await updateCustomerData(customer.customerID, customer);
        // Update the stored copy after a successful auto-save.
        originalCustomersRef.current[index] = { ...customer };
      } catch (error) {
        console.error("Error auto saving customer:", error);
      }
    }
  };

  return autoSaveCustomer;
}
